module.exports = "/_next/static/images/wrenchalt-5c761f22e37cfb922423e7946fb8ad9f.svg";